module.exports = __webpack_public_path__ + "static/media/btn-next.7d99f21a.svg";